import { LitElement, css, html, unsafeCSS } from 'lit';
import styles from './style.scss?inline';

export default class SotbitAvatar extends LitElement {
    static styles = [
        css`
            ${unsafeCSS(styles)}
        `,
    ];

    render() {
        return html`
            <div part="avatar">
                <slot name="image">
                    <div part="icon">
                        <sotbit-button-icon theme="dark" no-padding variant="secondary">
                            <sotbit-icon slot="content" icon="person" size="m"></sotbit-icon>
                        </sotbit-button-icon>
                    </div>
                </slot>
            </div>
        `;
    }
}
